import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiArrowLeft, FiLock } = FiIcons;

export default function Confidentialite() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-indigo-600 transition-colors mb-8">
        <SafeIcon icon={FiArrowLeft} />
        Retour au calculateur
      </Link>

      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
          <SafeIcon icon={FiLock} className="text-indigo-600 text-lg" />
        </div>
        <h1 className="text-3xl font-extrabold text-slate-900">Politique de Confidentialité</h1>
      </div>

      <div className="space-y-8">
        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">1. Collecte de données</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            <strong>salaire-smic.com</strong> ne collecte aucune donnée personnelle directement. Les salaires saisis dans le calculateur ne sont jamais transmis à nos serveurs : tous les calculs s'effectuent localement dans votre navigateur.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">2. Google AdSense</h2>
          <p className="text-slate-600 text-sm leading-relaxed mb-3">
            Ce site utilise <strong>Google AdSense</strong>, un service de régie publicitaire fourni par Google LLC. Google AdSense peut déposer des cookies sur votre appareil afin d'afficher des publicités personnalisées en fonction de vos centres d'intérêt et de votre historique de navigation.
          </p>
          <p className="text-slate-600 text-sm leading-relaxed mb-3">
            Ces cookies permettent à Google et à ses partenaires de vous proposer des annonces adaptées. Vous pouvez consulter et gérer vos préférences publicitaires via le <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">Gestionnaire de paramètres des annonces Google</a>.
          </p>
          <p className="text-slate-600 text-sm leading-relaxed">
            Pour en savoir plus sur la manière dont Google utilise vos données, consultez la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">Politique de confidentialité de Google</a>.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">3. Google Analytics</h2>
          <p className="text-slate-600 text-sm leading-relaxed mb-3">
            Ce site utilise <strong>Google Analytics</strong>, un service d'analyse d'audience fourni par Google LLC. Google Analytics collecte des informations anonymisées sur votre navigation (pages visitées, durée de session, type d'appareil, localisation approximative) afin de nous aider à améliorer <strong>salaire-smic.com</strong>.
          </p>
          <p className="text-slate-600 text-sm leading-relaxed">
            Ces données sont traitées par Google conformément à sa politique de confidentialité. Vous pouvez désactiver le suivi Google Analytics en installant le <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">module complémentaire de désactivation</a> proposé par Google.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">4. Cookies</h2>
          <p className="text-slate-600 text-sm leading-relaxed mb-3">
            Les cookies sont de petits fichiers texte stockés sur votre appareil. <strong>salaire-smic.com</strong> utilise des cookies déposés par des tiers (Google AdSense, Google Analytics) uniquement. Aucun cookie propriétaire n'est utilisé à des fins de traçage.
          </p>
          <p className="text-slate-600 text-sm leading-relaxed">
            Conformément à la réglementation européenne (RGPD) et aux recommandations de la CNIL, vous pouvez refuser ou supprimer ces cookies via les paramètres de votre navigateur.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">5. Vos droits</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous via la page <Link to="/contact" className="text-indigo-600 hover:underline">Contact</Link>.
          </p>
        </section>

        <p className="text-xs text-slate-400 text-center">Dernière mise à jour : avril 2026</p>
      </div>
    </div>
  );
}